import { render, staticRenderFns } from "./turnover.vue?vue&type=template&id=1e39b479&scoped=true"
import script from "./turnover.vue?vue&type=script&lang=js"
export * from "./turnover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e39b479",
  null
  
)

export default component.exports